import { render } from "./ViewChapters.vue?vue&type=template&id=58c54a88&scoped=true"
import script from "./ViewChapters.vue?vue&type=script&lang=js"
export * from "./ViewChapters.vue?vue&type=script&lang=js"

import "./ViewChapters.vue?vue&type=style&index=0&id=58c54a88&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c54a88"]])

export default __exports__